exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ec-compare-top-icon {\n  position: relative;\n}\n.ec-compare-top-icon .ec-compare-top-icon-count {\n  position: absolute;\n  right: -15px;\n  top: -15px;\n  font-size: 13px;\n  background-color: #5AD060;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n.ec-compare-top-icon:hover .ec-compare-top-icon-count {\n  background-color: #FDFFFD;\n  color: #5AD060;\n}", ""]);

// exports
